import {
  PropsWithChildren,
  ReactNode,
  useLayoutEffect,
  useRef,
  useState,
} from "react";

export interface EmptyFallbackProps extends PropsWithChildren {
  fallback?: ReactNode;
}

export function EmptyFallback({
  fallback,
  children,
  ...props
}: EmptyFallbackProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [isEmpty, setEmpty] = useState(false);

  useLayoutEffect(() => {
    const { current } = ref;
    if (!current) return;

    setEmpty(current.childElementCount <= 0);
    const observer = new MutationObserver(() => {
      setEmpty(current.childElementCount <= 0);
    });
    observer.observe(current, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  if (!children) {
    return fallback;
  }

  return (
    <>
      {isEmpty && fallback}
      <div
        {...props}
        ref={ref}
        style={{ display: isEmpty ? "none" : "contents" }}
      >
        {children}
      </div>
    </>
  );
}
